import { render, staticRenderFns } from "./goods_scroll.vue?vue&type=template&id=8dccee54&scoped=true"
import script from "./goods_scroll.vue?vue&type=script&lang=js"
export * from "./goods_scroll.vue?vue&type=script&lang=js"
import style0 from "./goods_scroll.vue?vue&type=style&index=0&id=8dccee54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dccee54",
  null
  
)

export default component.exports